"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
var Platform;
(function (Platform) {
    Platform["WEB"] = "Web";
    Platform["HYBRID"] = "Hybrid";
    Platform["CC"] = "cc";
})(Platform = exports.Platform || (exports.Platform = {}));
//# sourceMappingURL=types.js.map